import { render, staticRenderFns } from "./TaskPointModal.vue?vue&type=template&id=614db374"
import script from "./TaskPointModal.vue?vue&type=script&lang=js"
export * from "./TaskPointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports